import Fields, { BrandFormValues } from 'Components/brands/Fields'
import withRouter from 'Components/Common/withRouter';
import { PRIVILEGE } from 'constants/privilege';
import { useFormik } from 'formik';
import withAccessControl from 'hoc/withAccessControl';
import useDocumentTitle from 'hooks/useDocumentTitle';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Card, CardBody, Form, Spinner } from 'reactstrap'
import { createNewBrand } from 'services/api/brands';
import { fetchBrandList } from 'slices/brand/list/thunk';
import { AppDispatch, RootState } from 'store';
import { NewBrand } from 'types/brand';
import { getErrorMessage } from 'utils/helpers';
import * as Yup from "yup";

const CreateBrand = (props: any) => {

    useDocumentTitle("Create Brand");

    const selectedAgency = useSelector((state: RootState) => state.auth.selectedAgency);
    const [loading, setLoading] = useState(false);
    const [brandLogo, setBrandLogo] = useState<File|null>(null);
    const dispatch: AppDispatch = useDispatch();

    const defaultBrand : BrandFormValues = {
        name: '',
        description: '',
        website_url: '',
        ig_handle: '',
        img_url: null,
    }

    const formFields = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: defaultBrand,
        validationSchema: Yup.object({
            name: Yup.string().required("Brand name field can't be empty").max(50, "Maximum 50 characters are allowed"),
            description: Yup.string().required("Brand description field can't be empty"),
            website_url: Yup.string().required("Brand website field can't be empty"),
        }),
        onSubmit: async (brand) => {
            try {
                if(brandLogo && brandLogo.size > 2 * 1024 * 1024){
                    formFields.setFieldError('img_url', "Image size must not exceed 2MB")
                    return;
                }

                setLoading(true);
                const newBrand: NewBrand = {...brand, ...(brandLogo ? {img: brandLogo} : {})}

                await createNewBrand(selectedAgency?.uuid!, newBrand);
                dispatch(fetchBrandList({ page: 1, force: true }));
                toast.success("Brand created successfully!");
                props.router.navigate('/brand');
            } catch (error) {
                toast.error(getErrorMessage(error, 'Failed to create new brand'));
            } finally {
                setLoading(false)
            }
        }
    });

    return (
        <div className="page-content">
            <div className="page-content-inner page-spacing">
                <div className="d-flex w-100 justify-content-between align-items-center pt-1 pb-5">
                    <h4 className="page-title">Create Brand</h4>
                </div>
                <Form className='needs-validation' onSubmit={(e) => {
                    e.preventDefault();
                    formFields.handleSubmit();
                    return false;
                }}>
                    <Card className="mt-2">
                        <CardBody className='px-5 py-0'>
                            <Fields formFields={formFields} onBrandLogoChange={(logo) => setBrandLogo(logo)} />
                        </CardBody>
                    </Card>
                    <div className="d-flex justify-content-between mb-4">
                        <Link to={{ pathname: '/brand' }} type='button' className="theme-btn theme-btn-lg btn-primary-outlined"><i className='bx fs-4 bx-left-arrow-alt me-2' ></i>Back</Link>

                        <button type='submit' disabled={loading} className="theme-btn theme-btn-lg btn-gradient form-continue-btn">
                            {
                                loading ? <Spinner size="sm" className='me-2'> Loading... </Spinner> : <React.Fragment>Save <i className='bx fs-4 bx-right-arrow-alt' ></i></React.Fragment>
                            }
                        </button>
                    </div>
                </Form>
            </div>

        </div>
    )
}

export default withAccessControl(withRouter(CreateBrand), PRIVILEGE.BRAND.BRAND.CREATE)